import React from 'react';
import { IconProps } from '../types';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';
import styles from '../Icons.module.scss';

const ThreeDotsHorizontalSolidIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });

    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M4 9.2C4.33333 9.2 4.61653 9.0832 4.8496 8.8496C5.0832 8.61653 5.2 8.33333 5.2 8C5.2 7.66667 5.0832 7.38347 4.8496 7.1504C4.61653 6.9168 4.33333 6.8 4 6.8C3.66667 6.8 3.38347 6.9168 3.1504 7.1504C2.9168 7.38347 2.8 7.66667 2.8 8C2.8 8.33333 2.9168 8.61653 3.1504 8.8496C3.38347 9.0832 3.66667 9.2 4 9.2ZM8 9.2C8.33333 9.2 8.61653 9.0832 8.8496 8.8496C9.0832 8.61653 9.2 8.33333 9.2 8C9.2 7.66667 9.0832 7.38347 8.8496 7.1504C8.61653 6.9168 8.33333 6.8 8 6.8C7.66667 6.8 7.38347 6.9168 7.1504 7.1504C6.9168 7.38347 6.8 7.66667 6.8 8C6.8 8.33333 6.9168 8.61653 7.1504 8.8496C7.38347 9.0832 7.66667 9.2 8 9.2ZM12 9.2C12.3333 9.2 12.6165 9.0832 12.8496 8.8496C13.0832 8.61653 13.2 8.33333 13.2 8C13.2 7.66667 13.0832 7.38347 12.8496 7.1504C12.6165 6.9168 12.3333 6.8 12 6.8C11.6667 6.8 11.3835 6.9168 11.1504 7.1504C10.9168 7.38347 10.8 7.66667 10.8 8C10.8 8.33333 10.9168 8.61653 11.1504 8.8496C11.3835 9.0832 11.6667 9.2 12 9.2ZM8 16C6.89333 16 5.85333 15.7899 4.88 15.3696C3.90667 14.9499 3.06 14.38 2.34 13.66C1.62 12.94 1.05013 12.0933 0.6304 11.12C0.210133 10.1467 0 9.10667 0 8C0 6.89333 0.210133 5.85333 0.6304 4.88C1.05013 3.90667 1.62 3.06 2.34 2.34C3.06 1.62 3.90667 1.04987 4.88 0.6296C5.85333 0.209867 6.89333 0 8 0C9.10667 0 10.1467 0.209867 11.12 0.6296C12.0933 1.04987 12.94 1.62 13.66 2.34C14.38 3.06 14.9499 3.90667 15.3696 4.88C15.7899 5.85333 16 6.89333 16 8C16 9.10667 15.7899 10.1467 15.3696 11.12C14.9499 12.0933 14.38 12.94 13.66 13.66C12.94 14.38 12.0933 14.9499 11.12 15.3696C10.1467 15.7899 9.10667 16 8 16Z"
                fill={color || '#969696'}
            />
        </svg>
    );
};

export default React.memo(ThreeDotsHorizontalSolidIcon);
